module.exports = __webpack_public_path__ + "img/tunad.7efcdba2.svg";